<template xmlns="http://www.w3.org/1999/html">
    <div>
        <Wp_mini_grow_task_card style="margin-top: 20px">
            <div slot="title">
                成长任务1：升级超级会员
            </div>
            <div slot="content">
                <van-row>
                    <van-col span="18">
                        <div v-if="btn_status" style="color: #ce9b0b">
                            您已升级为超级会员！<br>
                            您的会员编号为：<span style="color: red;">{{$common.gloabl_wx_mini_user_info.channel_name}}</span>
                        </div>
                        <div v-else>
                            ①自己拉一个人数大于<span style="color: red;">50人</span>的微信群;<br/>
                            ②上传<span style="color: red;">两张截图</span>;<br/>
                            ③上传提交后，工作人员会在<span style="color: red;">24小时内</span>为您审核;<br/>
                            升级超级会员开启赚钱特权
                        </div>

                    </van-col>
                    <van-col span="6" style="text-align: center; line-height: 2.5">
                        <van-button type="danger" @click="upgradeMember" :disabled="btn_status" style="width: 90%">升级</van-button>
                    </van-col>
                </van-row>
                <div style="display: inline-flex; margin-top: 8px; background-color: rgba(255,255,255, 0.9); padding: 2px 5px; border-radius: 20px; border: 0.3px solid #d9d9d9" @click="showVideo(video_task_1)">
                    <van-icon name="play-circle" color="#F65452" size="25"></van-icon>
                    <div style="height: 25px; line-height: 25px; margin: 0px 10px; color: #F65452">查看教学视频</div>
                </div>
            </div>
        </Wp_mini_grow_task_card>

        <Wp_mini_grow_task_card style="margin-top: 20px">
            <div slot="title">
                成长任务2：开通智能发品助理
            </div>
            <div slot="content">
                升级为超级会员以后，我们的工作人员将与您联系，并帮助您开通智能发品助理，请保持电话畅通；
                助理每日精心选择优质优惠商品在您的微信群里推广，您可在会员界面查看助理推广商品为您带来的收入明细。
                如成功开通超级会员24小时后仍未与您联系，请您与我们的工作人员联系。
<!--                <br/>微信号：wpjx04-->
                <br/>微信号：haiyan2064
            </div>
        </Wp_mini_grow_task_card>

        <Wp_mini_grow_task_card style="margin-top: 20px">
            <div slot="title">
                成长任务3：学习选品及群内推广
            </div>
            <div slot="content">
                在小程序首页选品发到您的微信群里，用户购买您就会获得推广收益，收益次月提现，坚持在微信群里发品，轻松赚取生活费。
            </div>
        </Wp_mini_grow_task_card>

        <Wp_mini_grow_task_card style="margin-top: 20px">
            <div slot="title">
                成长任务4：学会转链
            </div>
            <div slot="content">
                转链就是将别人的推广链接转成自己的推广链接；复制爆款的商品文案链接，进入万品京选小程序完成转链后再转发，不然就是替别人做推广了。
                <div style="display: inline-flex; margin-top: 8px; background-color: rgba(255,255,255, 0.9); padding: 2px 5px; border-radius: 20px; border: 0.3px solid #d9d9d9" @click="showVideo(video_task_4)">
                    <van-icon name="play-circle" color="#F65452" size="25"></van-icon>
                    <div style="height: 25px; line-height: 25px; margin: 0px 10px; color: #F65452">查看教学视频</div>
                </div>
            </div>
        </Wp_mini_grow_task_card>

        <Wp_mini_grow_task_card style="margin-top: 20px">
            <div slot="title">
                成长任务5：如何查看佣金与提现
            </div>

            <div slot="content">
                <div style="display: inline-flex; margin-top: 8px; background-color: rgba(255,255,255, 0.9); padding: 2px 5px; border-radius: 20px; border: 0.3px solid #d9d9d9" @click="showVideo(video_task_5)">
                    <van-icon name="play-circle" color="#F65452" size="25"></van-icon>
                    <div style="height: 25px; line-height: 25px; margin: 0px 10px; color: #F65452">查看教学视频</div>
                </div>
            </div>
        </Wp_mini_grow_task_card>

        <Wp_mini_grow_task_card style="margin-top: 20px">
            <div slot="title">
                成长任务6：邀请好友加入
            </div>

            <div slot="content">
                <van-row>
                    <van-col span="18">
                        <div>
                            通过"分享素材"，邀请身边的朋友加入，您将获得额外的平台奖励；通过您转发的小程序注册自动成为您的下级会员，无需填写验证码。
                        </div>

                    </van-col>
                    <van-col span="6" style="text-align: center; line-height: 2.5">
                        <van-button type="danger" @click="inviteFriend" style="width: 90%">邀请</van-button>
                    </van-col>
                </van-row>
                <div style="display: inline-flex; margin-top: 8px; background-color: rgba(255,255,255, 0.9); padding: 2px 5px; border-radius: 20px; border: 0.3px solid #d9d9d9" @click="showVideo(video_task_6)">
                    <van-icon name="play-circle" color="#F65452" size="25"></van-icon>
                    <div style="height: 25px; line-height: 25px; margin: 0px 10px; color: #F65452">查看教学视频</div>
                </div>
            </div>
        </Wp_mini_grow_task_card>

        <Wp_mini_grow_task_card style="margin-top: 20px">
            <div slot="title">
                成长任务7：如何向下级介绍万品京选
            </div>

            <div slot="content">
                <div style="display: inline-flex; margin-top: 8px; background-color: rgba(255,255,255, 0.9); padding: 2px 5px; border-radius: 20px; border: 0.3px solid #d9d9d9" @click="showVideo(video_task_7)">
                    <van-icon name="play-circle" color="#F65452" size="25"></van-icon>
                    <div style="height: 25px; line-height: 25px; margin: 0px 10px; color: #F65452">查看教学视频</div>
                </div>
            </div>
        </Wp_mini_grow_task_card>

        <Wp_mini_grow_task_card style="margin-top: 20px">
            <div slot="title">
                成长任务8：教朋友如何在万品京选实现购物省钱
            </div>

            <div slot="content">
                <div style="display: inline-flex; margin-top: 8px; background-color: rgba(255,255,255, 0.9); padding: 2px 5px; border-radius: 20px; border: 0.3px solid #d9d9d9" @click="showVideo(video_task_8)">
                    <van-icon name="play-circle" color="#F65452" size="25"></van-icon>
                    <div style="height: 25px; line-height: 25px; margin: 0px 10px; color: #F65452">查看教学视频</div>
                </div>
            </div>
        </Wp_mini_grow_task_card>

    </div>
</template>

<script>
    import Wp_mini_grow_task_card from "../custom/Wp_mini_grow_task_card";
    import {Dialog} from 'vant';
    export default {
        name: "Wp_mini_guide_new_member",
        components: {Wp_mini_grow_task_card},

        inject:["wp_mini_guide"],

        data(){
            return{
                btn_status: false,
                video_task_1: '/images/video_task_1.mp4',
                video_task_4: '/images/video_task_4.mp4',
                video_task_5: '/images/video_task_5.mp4',
                video_task_6: '/images/video_task_6.mp4',
                video_task_7: '/images/video_task_7.mp4',
                video_task_8: '/images/video_task_8.mp4',

                video_title_data: {
                    video_task_1: '升级超级会员解锁更多权益',
                    video_task_4: '教你使用转链功能',
                    video_task_5: '如何查看佣金与提现',
                    video_task_6: '如何邀请好友加入万品京选',
                    video_task_7: '万品京选是什么',
                    video_task_8: '如何在万品京选实现购物省钱',
                }
            }
        },

        created(){
            this.initUpgradeButton();
        },

        methods:{

            showVideo(video_url){
                this.$log(encodeURIComponent(video_url))
                this.$log(encodeURI(video_url))
                let title_key = video_url.substring(video_url.indexOf('/', 1) + 1, video_url.indexOf('.'));
                this.$router.push('video_page?url=' + encodeURIComponent(video_url) + '&title=' + encodeURIComponent(this.video_title_data[title_key]));
            },

            inviteFriend(){
                this.wp_mini_guide.active = 2;
            },

            /**
             * 初始化升级按钮是否可用
             */
            initUpgradeButton(){
                let channelId = this.$common.gloabl_wx_mini_user_info.channel_id;

                // channelId = "";

                if(channelId){
                    this.btn_status = true;
                }else{
                    this.btn_status = false;
                }
            },

            upgradeMember(){
                // this.$router.push("mini_upgrade");
                // Dialog.confirm({
                //     title: '注意',
                //     message: '若您已创建好50人微信群，请[前往升级]，若未创建好，请[返回创建]',
                //     confirmButtonText: '前往升级',
                //     cancelButtonText: '返回创建'
                // });
                this.navigateToUpgrade();
            },


            /**
             * 打开小程序中的详情界面
             */
            navigateToUpgrade() {
                this.$common.navigateToMiniProgramPage("../wp_upgrade/wp_upgrade?");
            },

        }
    }
</script>

<style scoped>

</style>